import declareCianSentryConfiguration from '@cian/sentry';
import { calculateEnvironmentByHost } from '@cian/utils/lib/shared/calculate_environment_by_host';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Store } from 'redux';
import { Provider } from 'react-redux';

import { App } from '../app/containers/app/app';
import { Home } from '../app/containers/home/home';
import { configureStore } from '../app/redux/store';
import { createMakeRequest } from './client';
import { initializeGeoLinks } from './geo_links';

// TODO: не приводить тип
const store: Store = configureStore(
  {
    makeRequest: createMakeRequest(window.__mainpage_api_host__ || window.location.host),
  },
  window.__mainpage_state__,
);

declareCianSentryConfiguration({
  dsn: '//8c414c90a37a47498afca119c147980a@sentry-front.cian.ru/3',
  environment: calculateEnvironmentByHost(window.location.host),
  release: (window.__mainpage_sentry__ && window.__mainpage_sentry__.release) || 'local',
  matchUrl: (url: string) => {
    return [
      /mainpage\.js/,
    ].some(re => re.test(url));
  },
});

ReactDOM.hydrate(
  <Provider store={store} key="provider">
    <App store={store}>
      <Home section={window.__mainpage_section__} />
    </App>
  </Provider>,
  // TODO: не приводить тип
  document.getElementById('mainpage') as Element,
);

initializeGeoLinks();
